/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Lokalizacja */
export interface LocationDto {
  /**
   * Id lokalizacji
   * @format int32
   */
  id?: number;
  /** Pełna lokalizacja */
  fullName?: string;
}

/** Lokalizacja */
export interface OsmLocationDto {
  /**
   * Id lokalizacji
   * @format int32
   */
  id?: number;
  /** Pełna lokalizacja */
  fullName?: string;
}

export interface TenderFilterResponse {
  /**
   * Id filtra
   * @format int64
   * @example 1
   */
  filterId: number;
  /**
   * Nazwa filtra
   * @example "Any filter name"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms?: boolean | null;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail?: boolean | null;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush?: boolean | null;
  /**
   * Cena od
   * @format double
   * @example 250000
   */
  priceFrom?: number | null;
  /**
   * Cena do
   * @format double
   * @example 5500000
   */
  priceTo?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 2500
   */
  pricePerSquareMeterFrom?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 25000
   */
  pricePerSquareMeterTo?: number | null;
  /**
   * Powierzchnia od
   * @format double
   * @example 250.25
   */
  areaFrom?: number | null;
  /**
   * Powierzchnia do
   * @format double
   * @example 250.55
   */
  areaTo?: number | null;
  /** Lokalizacje */
  locations?: LocationDto[];
  /** Lokalizacje OSM */
  filterLocations?: OsmLocationDto[];
  /**
   * Pożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  wantedKeywords?: (string | null)[];
  /**
   * Niepożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  unwantedKeywords?: (string | null)[];
  /**
   * Typy nieruchomości
   * @example ["Mieszkania","Domy","Grunty"]
   */
  types?: TenderFilterResponseTypesEnum;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @min 1
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-04"
   */
  dateAddedTo?: string | null;
  /**
   * Akceptuj puste wartości
   * @example true
   */
  includeZeroArea?: boolean | null;
  /**
   * Moduł
   * @default "TENDER"
   */
  module: string;
}

export interface TenderFilterCreateRequest {
  /**
   * Nazwa filtra
   * @example "Any filter name"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms?: boolean | null;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail?: boolean | null;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush?: boolean | null;
  /**
   * Cena od
   * @format double
   * @example 250000
   */
  priceFrom?: number | null;
  /**
   * Cena do
   * @format double
   * @example 5500000
   */
  priceTo?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 2500
   */
  pricePerSquareMeterFrom?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 25000
   */
  pricePerSquareMeterTo?: number | null;
  /**
   * Powierzchnia od
   * @format double
   * @example 250.25
   */
  areaFrom?: number | null;
  /**
   * Powierzchnia do
   * @format double
   * @example 250.55
   */
  areaTo?: number | null;
  /** Lokalizacje */
  locations?: LocationDto[];
  /** Lokalizacje OSM */
  filterLocations?: OsmLocationDto[];
  /**
   * Pożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  wantedKeywords?: (string | null)[];
  /**
   * Niepożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  unwantedKeywords?: (string | null)[];
  /**
   * Typy nieruchomości
   * @example ["Mieszkania","Domy","Grunty"]
   */
  types?: TenderFilterCreateRequestTypesEnum;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @min 1
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-04"
   */
  dateAddedTo?: string | null;
  /**
   * Akceptuj puste wartości
   * @example true
   */
  includeZeroArea?: boolean | null;
}

export interface TenderSearchingRequest {
  /**
   * Domyślnie Sortowanie
   * Do wyboru DATE_DESC oraz DATE_ASC
   */
  sortType?: TenderSearchingRequestSortTypeEnum;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-01"
   */
  dateAddedTo?: string | null;
  /**
   * Cena od
   * @format double
   * @example 250000
   */
  priceFrom?: number | null;
  /**
   * Cena do
   * @format double
   * @example 5500000
   */
  priceTo?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 2500
   */
  pricePerSquareMeterFrom?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 25000
   */
  pricePerSquareMeterTo?: number | null;
  /**
   * Powierzchnia od
   * @format double
   * @example 250.25
   */
  areaFrom?: number | null;
  /**
   * Powierzchnia do
   * @format double
   * @example 250.55
   */
  areaTo?: number | null;
  /**
   * Typ nieruchomości
   * @example ["Mieszkania","Grunty"]
   */
  types?: (string | null)[];
  /**
   * Akceptuj puste wartości
   * @example true
   */
  includeZeroArea?: boolean | null;
  /**
   * Niepożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  unwantedKeywords?: (string | null)[];
  /**
   * Pożądane słowa kluczowe
   * @example ["XYZ","YXZ","YZX"]
   */
  wantedKeywords?: (string | null)[];
  /** Lokalizacje */
  locations?: LocationDto[];
  /** Lokalizacje OSM */
  filterLocations?: OsmLocationDto[];
  /** Pokazywanie odblokowanych ogłoszeń */
  unlockedAdvertisements?: boolean;
}

/**
 * Notatki
 * @example {"noteId":null,"content":"Dowolny opis","date":"2024-08-22T07:34:12.770Z"}
 */
export interface NoteResponse {
  /**
   * Id notatki
   * @format int64
   * @example 1
   */
  noteId: number;
  /**
   * Treść notatki
   * @example "Dowolna treść"
   */
  content: string;
  /**
   * Data dodania notatki
   * @format date-time
   */
  date: string;
}

/**
 * Reakcja
 * @example {"likeStatus":true,"unlikeStatus":false,"viewedStatus":false,"outdatedStatus":false,"arrangedStatus":false,"phoneStatus":false,"hideStatus":false,"openedStatus":false}
 */
export interface ReactionResponse {
  /**
   * Status 'lubię'
   * @example true
   */
  likeStatus?: boolean;
  /**
   * Status 'nie lubię'
   * @example true
   */
  unlikeStatus?: boolean;
  /**
   * Status 'obejrzane'
   * @example true
   */
  viewedStatus?: boolean;
  /**
   * Status 'nieaktualne'
   * @example true
   */
  outdatedStatus?: boolean;
  /**
   * Status 'spotkania'
   * @example true
   */
  arrangedStatus?: boolean;
  /**
   * Status 'telefonu'
   * @example true
   */
  phoneStatus?: boolean;
  /**
   * Status 'ukrycia
   * @example true
   */
  hideStatus?: boolean;
  /**
   * Status 'otwarte'
   * @example true
   */
  openedStatus?: boolean;
}

/** Informacja o blokadzie ogłoszenia */
export interface TenderBlockageResponse {
  /**
   * Id oryginalnego ogłoszenia zablokowanego
   * Id oryginalnego ogłoszenia mogą się zmienić podczas działania aplikacji
   * @format int64
   * @example 1
   */
  originalAdvertisementId: number;
  /**
   * Czas blokady w dniach
   * @format int32
   * @example 14
   */
  days: number;
  /**
   * Data blokady
   * @format date-time
   */
  blockedDate: string;
  /**
   * Nazwa użytkownika blokującego ogłoszenie
   * @example "Jan Kowalski"
   */
  userName: string;
  /**
   * Czy blokada jest stała
   * @example true
   */
  permanentlyBlocked: boolean;
}

export interface TenderResponse {
  /**
   * Id ogłoszenia
   * @format int64
   */
  tenderId: number;
  /** Id ogłoszenia */
  encryptedId: string;
  /**
   * Moduł
   * @example "TENDER"
   */
  module: string;
  /**
   * Lokalizacja
   * @example "Wielkopolskie, Leszczyński, Święciechowa, Ul. Leszczyńska"
   */
  location: string;
  /**
   * Liczba notatek
   * @format int32
   * @example 2
   */
  numberOfNotes: number;
  newestNote?: NoteResponse;
  reaction?: ReactionResponse;
  /**
   * Link do ogłoszenia
   * @example "https://komunikaty.pl/link"
   */
  link: string;
  /**
   * Tytuł ogłoszenia
   * @example "Tytuł"
   */
  title: string;
  /**
   * Data dodania ogłoszenia
   * @example "17.12.2027, 09:53"
   */
  dateAdded: string;
  /**
   * Cena
   * @format double
   * @example 250000
   */
  price?: number | null;
  /**
   * Cena za m2
   * @format double
   * @example 2500
   */
  pricePerSquareMeter?: number | null;
  /**
   * Powierzchnia
   * @format double
   * @example 250.25
   */
  area?: number | null;
  /**
   * Data licytacji
   * @example "17.11.2027"
   */
  tenderDate?: string;
  /**
   * Typ nieruchomości
   * @example "Mieszkania"
   */
  type?: string;
  /**
   * Nazwa portalu
   * @example "Licytacje Komornik"
   */
  portal: string;
  /**
   * Zdjęcia
   * @example ["20240725141005_gNnqQucA.web","20230725141105_gNnqQqwe.webp"]
   */
  photos?: string[];
  blockage?: TenderBlockageResponse;
}

export interface Page {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  last?: boolean;
  /** @format int32 */
  size?: number;
  content?: object[];
  /** @format int32 */
  number?: number;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  empty?: boolean;
}

export interface PageableObject {
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  offset?: number;
  sort?: SortObject;
  paged?: boolean;
  unpaged?: boolean;
}

export interface SortObject {
  sorted?: boolean;
  empty?: boolean;
  unsorted?: boolean;
}

export interface TenderDetailsResponse {
  /**
   * Id ogłoszenia
   * @format int64
   * @example 1
   */
  tenderId: number;
  /** Id ogłoszenia */
  encryptedId: string;
  /**
   * Tytuł ogłoszenia
   * @example "Tytuł"
   */
  title: string;
  /**
   * Cena
   * @format double
   * @example 250000
   */
  price?: number | null;
  /**
   * Cena za m2
   * @format double
   * @example 2500
   */
  pricePerSquareMeter?: number | null;
  /**
   * Powierzchnia
   * @format double
   * @example 250.25
   */
  area?: number | null;
  /**
   * Data licytacji
   * @example "17.11.2027"
   */
  tenderDate?: string;
  /**
   * Lokalizacja
   * @example "Wielkopolskie, Leszczyński, Święciechowa, Ul. Leszczyńska"
   */
  location: string;
  /**
   * Data dodania ogłoszenia
   * @example "17.12.2027, 09:53"
   */
  dateAdded: string;
  /**
   * Link do ogłoszenia
   * @example "https://komunikaty.pl/link"
   */
  link: string;
  /**
   * Typ nieruchomości
   * @example "Mieszkania"
   */
  type?: string;
  /**
   * Opis
   * @example "Dowolny opis"
   */
  description?: string;
  reaction?: ReactionResponse;
  /**
   * Notatki
   * @example {"noteId":null,"content":"Dowolny opis","date":"2024-08-22T07:34:12.770Z"}
   */
  notes?: NoteResponse[];
  /**
   * Portal
   * @example "Komunikaty"
   */
  portalName: string;
  /**
   * Zdjęcia
   * @example ["20240725141005_gNnqQucA.web","20230725141105_gNnqQqwe.webp"]
   */
  photos?: string[];
  /**
   * Meta
   * @example [{"key":"Udogodnienia","value":"Prąd, Siła"},{"name":"Rodzaj przetargu","value":"Ustny"}]
   */
  meta?: TenderMetaResponse[];
}

/**
 * Meta
 * @example [{"key":"Udogodnienia","value":"Prąd, Siła"},{"name":"Rodzaj przetargu","value":"Ustny"}]
 */
export interface TenderMetaResponse {
  /**
   * Klucz
   * @example "Udogodnienia"
   */
  key: string;
  /**
   * Wartość
   * @example "Telefon, Internet"
   */
  value: string;
}

export interface TenderFilterListResponse {
  /**
   * Id filtra
   * @format int64
   * @example 1
   */
  filterId: number;
  /** Nazwa filtra */
  name: string;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
}

/**
 * Typy nieruchomości
 * @example ["Mieszkania","Domy","Grunty"]
 */
export enum TenderFilterResponseTypesEnum {
  Mieszkania = "Mieszkania",
  Domy = "Domy",
  Grunty = "Grunty",
  Lokal = "Lokal",
  Pozostale = "Pozostałe",
}

/**
 * Typy nieruchomości
 * @example ["Mieszkania","Domy","Grunty"]
 */
export enum TenderFilterCreateRequestTypesEnum {
  Mieszkania = "Mieszkania",
  Domy = "Domy",
  Grunty = "Grunty",
  Lokal = "Lokal",
  Pozostale = "Pozostałe",
}

/**
 * Domyślnie Sortowanie
 * Do wyboru DATE_DESC oraz DATE_ASC
 */
export enum TenderSearchingRequestSortTypeEnum {
  DATE_DESC = "DATE_DESC",
  DATE_ASC = "DATE_ASC",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  v2 = {
    /**
     * No description
     *
     * @tags tender-filter-controller
     * @name EditFilter
     * @summary Edycja filtra
     * @request PUT:/v2/tender-offer/filter/edit
     * @secure
     */
    editFilter: (data: TenderFilterResponse, params: RequestParams = {}) =>
      this.http.request<object, void>({
        path: `/v2/tender-offer/filter/edit`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tender-filter-controller
     * @name CreateFilter
     * @summary Tworzenie nowego filtra
     * @request POST:/v2/tender-offer/filter/create
     * @secure
     */
    createFilter: (data: TenderFilterCreateRequest, params: RequestParams = {}) =>
      this.http.request<number, void>({
        path: `/v2/tender-offer/filter/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tender-controller
     * @name FindTenders
     * @summary Pobieranie listy ogłoszeń
     * @request POST:/v2/tender-offer/advertisement
     * @secure
     */
    findTenders: (
      query: {
        /** @format int32 */
        page: number;
        /** @format int32 */
        size: number;
      },
      data: TenderSearchingRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<TenderResponse, any>({
        path: `/v2/tender-offer/advertisement`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tender-controller
     * @name GetTenderDetailsByEncryptedId
     * @summary Pobieranie szczegołów podanego ogłoszenia według zakodowanego Id
     * @request GET:/v2/tender-offer/single-advertisement/detail
     * @secure
     */
    getTenderDetailsByEncryptedId: (
      query: {
        hash: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<TenderDetailsResponse, any>({
        path: `/v2/tender-offer/single-advertisement/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tender-filter-controller
     * @name FindUserFilters
     * @summary Pobieranie listy filtrów użytkownika (Bez szczegółów)
     * @request GET:/v2/tender-offer/filter/list
     * @secure
     */
    findUserFilters: (params: RequestParams = {}) =>
      this.http.request<TenderFilterListResponse, any>({
        path: `/v2/tender-offer/filter/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tender-filter-controller
     * @name GetFilterDetails
     * @summary Pobieranie wszystkie szczegóły poszczególnego filtra
     * @request GET:/v2/tender-offer/filter/details
     * @secure
     */
    getFilterDetails: (
      query: {
        /**
         * Id filtra
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<TenderFilterResponse, string>({
        path: `/v2/tender-offer/filter/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tender-controller
     * @name GetTenderDetailsById
     * @summary Pobieranie szczegołów podanego ogłoszenia według zwykłego Id
     * @request GET:/v2/tender-offer/advertisement/details
     * @secure
     */
    getTenderDetailsById: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<TenderDetailsResponse, any>({
        path: `/v2/tender-offer/advertisement/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tender-filter-controller
     * @name DeleteFilter
     * @summary Usuwanie filtra
     * @request DELETE:/v2/tender-offer/filter/delete
     * @secure
     */
    deleteFilter: (
      query: {
        /**
         * Id filtra
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, void>({
        path: `/v2/tender-offer/filter/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
}
